export default "__VITE_ASSET__BOfBCn6___"